export const DEPT_COLORS = {
  MX:    { bg: 'bg-green-100',  text: 'text-green-800',  dot: 'bg-green-500',  hex: '#22c55e' },
  AVI:   { bg: 'bg-blue-100',   text: 'text-blue-800',   dot: 'bg-blue-500',   hex: '#3b82f6' },
  INT:   { bg: 'bg-orange-100', text: 'text-orange-800', dot: 'bg-orange-500', hex: '#f97316' },
  PA:    { bg: 'bg-pink-100',   text: 'text-pink-800',   dot: 'bg-pink-500',   hex: '#ec4899' },
  QA:    { bg: 'bg-yellow-100', text: 'text-yellow-800', dot: 'bg-yellow-500', hex: '#eab308' },
  EXT:   { bg: 'bg-gray-200',   text: 'text-gray-700',   dot: 'bg-gray-500',   hex: '#6b7280' },
}

export const DEPT_PRIORITY = ['MX', 'AVI', 'INT', 'PA', 'QA', 'EXT']

// Returns an approximation of the *-800 Tailwind shade for a given hex color.
export function darkenHex(hex) {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return `rgb(${Math.round(r * 0.45)}, ${Math.round(g * 0.45)}, ${Math.round(b * 0.45)})`
}
